// @flow

import * as React from "react";
import { useDispatch } from "react-redux";

import actions from "../actions/";

const useSimpleNav = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(actions.setSimpleNav());

        return function cleanup() {
            dispatch(actions.unsetSimpleNav());
        };
    }, []); //eslint-disable-line
};

export default useSimpleNav;
